import { setMaintenanceCategory } from "./MaintenanceService";

export default {
  name: "FamilyEngagementPlus",
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null
  },
  created() {
    this.sendDefaultValueForModule();
  },
  computed: {
    isDisable(): boolean {
      return !this.facility.featureMaintenance;
    },
    maintenanceCategory: {
      get() {
        return (
          (this.facility.featureMaintenance ?? true) &&
          (this.facility.maintenanceEnabled ?? true)
        );
      }
    },
  },
  methods: {
    sendDefaultValueForModule() {
      this.$emit('send-bundle-value', this.maintenanceCategory)
    },
    maintenanceBundleUpdate(value) {
      this.maintenanceCategoryUpdate(value);
    },
    maintenanceCategoryUpdate(value) {
      this.facility.featureMaintenance = value;
      setMaintenanceCategory(this.facility, value)

      if(value) {
        this.$emit('send-bundle-value', this.maintenanceCategory)
      }
    }
  }
}